var components = [
	'dialog-cancel',
	'dialog-warning-navigation',
	'dialog-loading',
	'dialog-logout',
	'dialog-remove',
	'drawer-menu',
	'drawer-user',
	'review-headline',
	'review-products',
	'footer-component',
	'toolbar-component',
	'cart',
	'location-list',
	'location-list-2',
	'location-list-data',
	'location-item',
	'product-list',
	'snack'
]

export default {
	install(Vue) {
		Vue.prototype.$_ = require('underscore')
		components.forEach(element => {
			Vue.component(element, require('./components/' + element + '.vue').default)
		})
	}
}